import { css, Global } from '@emotion/react'

import HAVDesignTokens from './HAVDesignTokens'

const CSStyles = `
  *, *:before, *:after {
    box-sizing: border-box;
  }

  body, html {
    line-height: ${HAVDesignTokens.typography.lineHeight};
    font-family: ${HAVDesignTokens.typography.font.primary}, Roboto, Nakula, Arial;
  }

  label, select, button { cursor: pointer; }
  img { max-width: 100%; }

  /* ===== Scrollbar CSS ===== */
  /* Firefox */
  * {
    scrollbar-width: auto;
  }

  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: ${HAVDesignTokens.spacing.stack.x.medium};
  }

  *::-webkit-scrollbar-track {
    background: ${HAVDesignTokens.palette.neutral.white};
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${HAVDesignTokens.palette.main.primary};
    border-radius: ${HAVDesignTokens.spacing.stack.small};
    border: ${HAVDesignTokens.spacing.stack.x.small} solid ${HAVDesignTokens.palette.neutral.white};
  }
`

const GlobalStyle = () => (
  <Global
    styles={css`
      ${CSStyles}
    `}
  />
)

export default GlobalStyle
